import { render, staticRenderFns } from "./emailsent.vue?vue&type=template&id=0473283c&"
import script from "./emailsent.vue?vue&type=script&lang=js&"
export * from "./emailsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports